/* ==========================================================================
   HEDERA — Drill-down category drawer (vanilla JS, isolated module)
   --------------------------------------------------------------------------
   Owns ONLY the content inside [data-hd-drilldown].
   It does not open, close, or otherwise touch the off-canvas drawer itself —
   that stays with assets/mobile-nav.js. It only listens for the drawer being
   closed so the next open starts again at level 1.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-hd-drilldown]');
    if (!root) return;
    if (root.dataset.hdReady === 'true') return;
    root.dataset.hdReady = 'true';

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hd-panel]'));
    if (!panels.length) return;

    var rootPanel = root.querySelector('#hd-dd-root') || panels[0];
    var stack = [rootPanel]; // stack[stack.length - 1] === visible panel
    var lastTrigger = [];    // trigger button per pushed level, for focus return

    function panelById(id) {
      if (!id) return null;
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].id === id) return panels[i];
      }
      return null;
    }

    function paint() {
      var active = stack[stack.length - 1];
      panels.forEach(function (panel) {
        var isActive = panel === active;
        var isParked = !isActive && stack.indexOf(panel) !== -1;
        panel.classList.toggle('is-active', isActive);
        panel.classList.toggle('is-parked', isParked);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        panel.inert = !isActive;
      });

      root.querySelectorAll('[data-hd-open]').forEach(function (btn) {
        var target = panelById(btn.getAttribute('data-hd-open'));
        btn.setAttribute('aria-expanded', target && stack.indexOf(target) !== -1 ? 'true' : 'false');
      });
    }

    function push(targetId, trigger) {
      var target = panelById(targetId);
      if (!target || target === stack[stack.length - 1]) return;
      stack.push(target);
      lastTrigger.push(trigger || null);
      paint();
      var scroller = target.querySelector('.hd-dd__scroll');
      if (scroller) scroller.scrollTop = 0;
      var title = target.querySelector('.hd-dd__title');
      if (title) {
        window.setTimeout(function () {
          try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); }
        }, 60);
      }
    }

    function pop() {
      if (stack.length < 2) return;
      stack.pop();
      var trigger = lastTrigger.pop();
      paint();
      if (trigger && document.contains(trigger)) {
        window.setTimeout(function () {
          try { trigger.focus({ preventScroll: true }); } catch (e) { trigger.focus(); }
        }, 60);
      }
    }

    function reset() {
      if (stack.length < 2) return;
      root.classList.add('hd-dd--no-anim');
      stack = [rootPanel];
      lastTrigger = [];
      paint();
      var scroller = rootPanel.querySelector('.hd-dd__scroll');
      if (scroller) scroller.scrollTop = 0;
      window.setTimeout(function () {
        root.classList.remove('hd-dd--no-anim');
      }, 60);
    }

    /* ---- interaction ---- */
    root.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-hd-open]');
      if (opener && root.contains(opener)) {
        event.preventDefault();
        push(opener.getAttribute('data-hd-open'), opener);
        return;
      }
      var backer = event.target.closest('[data-hd-back]');
      if (backer && root.contains(backer)) {
        event.preventDefault();
        pop();
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && stack.length > 1) {
        event.preventDefault();
        event.stopPropagation();
        pop();
      }
    });

    /* ---- reset to level 1 whenever the drawer is closed ---- */
    var drawer = root.closest('.offcanvas-header');
    if (drawer && 'MutationObserver' in window) {
      var wasOpen = drawer.classList.contains('open') || drawer.classList.contains('active');
      new MutationObserver(function () {
        var isOpen = drawer.classList.contains('open') || drawer.classList.contains('active');
        if (wasOpen && !isOpen) reset();
        wasOpen = isOpen;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
